import { PageHero } from "../components/site/PageHero";
import { ProductCard } from "../components/site/ProductCard";
import { Reveal } from "../components/site/motion";
import { PRODUCTS } from "../lib/products";

export default function Shop() {
  return (
    <div data-testid="shop-page">
      <PageHero
        testId="shop-hero"
        eyebrow="Shop"
        lines={["The bars.", "Coming soon."]}
        intro="Premium, handcrafted protein bars made with real, recognizable ingredients. 100g bars with approximately 25g of protein. Prices and full nutrition facts are coming soon."
      />
      <section className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pb-24 sm:pb-32">
        <div data-testid="product-grid" className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {PRODUCTS.map((p) => (
            <Reveal key={p.slug}><ProductCard product={p} /></Reveal>
          ))}
        </div>
        <Reveal>
          <p data-testid="more-flavors-line" className="mt-14 border-t-2 border-dano-ink pt-6 font-wide text-2xl sm:text-3xl uppercase">
            More flavors in <span className="text-dano-red">development.</span>
          </p>
        </Reveal>
      </section>
    </div>
  );
}
